/* *
 * ToC variables
 * */

// manage classes here
var tocClass = {
  el: 'aim-toc',
  title: 'aim-toc__title',
  icon: 'aim-toc__icon',
  navList: 'aim-toc__list',
  open: 'aim-toc--toggled'
};

// init variables
var i,
    h,
    x,
    tocs = document.querySelectorAll('.' + tocClass.el);

/* *
 * ToC init 
 * */

// next until (jQueryless function) used to find h3s between h2s
/*! nextUntil function from 
  * https://gomakethings.com/how-to-get-all-sibling-elements-until-a-match-is-found-with-vanilla-javascript/
  * Get all following siblings of each element up to but not including the element matched by the selector
  * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
  * @param  {Node}   elem     The element
  * @param  {String} selector The selector to stop at
  * @param  {String} filter   The selector to match siblings against [optional]
  * @return {Array}           The siblings
  */
var nextUntil = function (elem, selector, filter) {

  // Setup siblings array
  var siblings = [];

  // Get the next sibling element
  elem = elem.nextElementSibling;

  // As long as a sibling exists
  while (elem) {

    // If we've reached our match, bail
    if (elem.matches(selector)) break;

    // If filtering by a selector, check if the sibling matches
    if (filter && !elem.matches(filter)) {
      elem = elem.nextElementSibling;
      continue;
    }

    // Otherwise, push it to the siblings array
    siblings.push(elem);

    // Get the next sibling element
    elem = elem.nextElementSibling;

  }

  return siblings;

};

// find every instance of a toc and init
for ( i = 0; i < tocs.length; i++ ) {
    
  // loop variables
  var toc = tocs[i],
      tocNavList = toc.querySelector('.' + tocClass.navList),
      tocSubHeadings = toc.getAttribute('data-toc-subheading'),
      tocTarget = document.querySelector(toc.getAttribute('data-toc-targeting')),
      h2s = tocTarget.querySelectorAll('h2');
  
  // loop through h2s  
  for (h = 0; h < h2s.length; h++) {

    // loop variables
    var h2 = h2s[h], 
        h2Text = h2.innerText,
        headingID;
    
    // headingID generate automatically if no id
    headingID = h2.id ? h2.id : 'section_' + h2Text.toLowerCase().replace(/[^a-z\d]/g, '') + '_' + (h + 1); 

    // give h2s id if none exists
    if (!h2.id) h2.setAttribute( 'id', headingID );

    // create h2 links
    listLinkMaker( tocNavList, h2Text, '#' + headingID );

    // all h3s until the next h2 if subheadings true
    if (tocSubHeadings) {
      var h3s = nextUntil( h2, 'h2', 'h3' ); 

      // add list to newly created li if there are h3s under the h2
      if ( h3s.length > 0 ) {
        var subList = document.createElement('UL');
        tocNavList.children[h].appendChild(subList);
      }

      // loop through h3s
      for ( x = 0; x < h3s.length; x++ ) {
        // variables
        var h3 = h3s[x],
            h3Text = h3s[x].innerText,
            subberList = subList,
            subHeadingID;
        
        // headingID generate automatically if no id
        subHeadingID = h3.id ? h3.id : 'section_' + h3Text.toLowerCase().replace(/[^a-z\d]/g, '') + '_' + (h + 1); 

        // give h3s id if none exists
        if (!h3.id) h3.setAttribute( 'id', subHeadingID );

        // create h3 links
        listLinkMaker( subList, h3Text, '#' + subHeadingID );

      }
      
    }

  }
  
}


// lister function (creates toc links)
function listLinkMaker(list, text, url) {
  var li = document.createElement('LI'),
      div = document.createElement('DIV'),
      link = document.createElement('A'),
      innertext = document.createTextNode(text);

  var placeHolderBG = list.querySelector('.toc__placeholder');
  if (placeHolderBG) {
    placeHolderBG.parentNode.removeChild(placeHolderBG);
  }

  link.setAttribute('href', url);
  li.appendChild(div).appendChild(link).appendChild(innertext);
  list.appendChild(li);

  // Smooth scroll click handler
  link.addEventListener('click', function(e) {
    e.preventDefault(); // prevent default jump
    var targetEl = document.querySelector(url);
    if (targetEl) {
      targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Optional: update URL hash without jumping
      history.pushState(null, null, url);
    }
  });
}


/* *
 * ToC toggle / expander/ collapser (used for mobile)
 * */

// listen for click in tocClass.title
document.addEventListener('click', function (event) {
  // no tocClass.title, then kill it
  if (!event.target.closest('.' + tocClass.title)) return;
  // run the toggle function below
  tocToggle(event.target);
}, false);

// toggle the toc with the tocClass.open
function tocToggle( activator ) {
    console.log('hre');
    $('.aim-toc__nav').slideToggle();
    
  var toc = activator.closest('.' + tocClass.el);

  if (toc.classList.contains(tocClass.open)) {
    toc.classList.remove(tocClass.open);
  } else {
    toc.classList.add(tocClass.open);
  }
}

/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
if (!Element.prototype.closest) {
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }
  Element.prototype.closest = function (s) {
    var el = this;
    var ancestor = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (ancestor.matches(s)) return ancestor;
      ancestor = ancestor.parentElement;
    } while (ancestor !== null);
    return null;
  };
}
